import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, startWith, map } from 'rxjs';
import { DropdownOption } from '../input-dropdown/input-dropdown.component';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
  selector: 'app-input-with-filter',
  templateUrl: './input-with-filter.component.html',
  styleUrls: ['./input-with-filter.component.scss']
})
export class InputWithFilterComponent {

  @Input() control = new FormControl('');
  @Input() height: number = 25;
  @Input() options!: DropdownOption[];
  filteredOptions!: Observable<DropdownOption[]>;
  @Output() emitter = new EventEmitter();
  @Input() placeholder: string = '';

  ngOnInit() {
    this.seeList();
  }

  private _filter(value: any): DropdownOption[] {

    if (typeof value !== 'string') {
      return this.options;
    }

    const filterValue = value.toLowerCase();
    return value !== '' ? this.options.filter(option => option.label.toLowerCase().includes(filterValue)) : this.options;
  }


  seeList() {
    this.filteredOptions = this.control.valueChanges.pipe(
      startWith(''),
      map((value: any) => this._filter(value || '')),
    );
  }

  onOptionSelected(event: MatAutocompleteSelectedEvent) {
    this.control.setValue(event.option.value.label);
  }
}
